// frontend/src/utils/memory/prepareMemoryPayload.js

import { detectEmotionAndTone } from '../../utils/context/detectEmotionAndTone';
import { formatSearchResults } from '../../hooks/formatSearchResults'; // 👈 Import the formatter
import { debugLog } from '../logging/debugLog';

export function prepareMemoryPayload({ message, intent, context = {}, webSearchResults = [] }) {
  if (!message || typeof message !== 'string') {
    console.warn('⚠️ Invalid message passed to prepareMemoryPayload');
    return null;
  }

  // 🎯 Detect emotion and tone automatically
  const { emotion, tone } = detectEmotionAndTone(message);

  // 📚 Format search results if available
  let enhancedMessage = message.trim();
  if (Array.isArray(webSearchResults) && webSearchResults.length > 0) {
    const searchBlock = formatSearchResults(webSearchResults);
    enhancedMessage = `${searchBlock}${message.trim()}`;
  }

  const memoryPayload = {
    message: enhancedMessage,
    intent: intent || null,
    emotion: emotion || 'neutral',
    tone: tone || 'neutral',
    context: context || {},
  };

  debugLog('📦 Prepared memory payload:', memoryPayload);
  return memoryPayload;
}

export default prepareMemoryPayload;
